module.exports = __webpack_public_path__ + "img/video-poster.41fba2ae.jpg";